var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 80,
    viewBox: "0 0 65 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.471 0H27.2784H37.3814H51.3806C40.905 5 43.898 9.5 54.5567 21.2658C63.1443 31.3924 64.2673 39.8657 64.6598 45.5696L64.5958 45.5402C64.6383 46.2197 64.6598 46.9048 64.6598 47.5949C64.6598 65.4918 50.1852 80 32.3299 80C14.4746 80 0 65.4918 0 47.5949C0 46.9048 0.0215249 46.2197 0.0639386 45.5402L0 45.5696C0.392461 39.8657 1.51546 31.3924 10.1031 21.2658C10.3834 20.9353 10.6626 20.6069 10.9399 20.2809C18.4341 11.4687 24.4971 4.33946 12.471 0Z",
    fill: "#DD2736"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9693 30.176C45.9693 30.1415 45.9693 30.107 45.9693 30.0725V30.038C45.9693 30.0035 45.9337 29.969 45.9337 29.9344C45.8981 29.8999 45.8981 29.8654 45.8626 29.8309C45.8626 29.8309 45.8626 29.8309 45.827 29.7964C45.7914 29.8309 45.7559 29.7964 45.7203 29.7964L39.1764 26.1379C39.0341 26.0344 38.8207 26.0344 38.6784 26.1379L32.3834 29.6238L25.9462 26.0689C25.7684 25.9653 25.5905 25.9653 25.4127 26.0689L18.9399 29.7619C18.9043 29.7619 18.9043 29.7964 18.8687 29.8309C18.8687 29.8309 18.8687 29.8309 18.8332 29.8654C18.7976 29.8999 18.7976 29.9344 18.762 29.969C18.7265 30.0035 18.7265 30.038 18.7265 30.0725V30.107C18.6909 30.1415 18.6909 30.1415 18.6909 30.176C18.6909 30.176 18.6909 30.176 18.6909 30.2106V56.0961C18.6909 56.2687 18.7976 56.4413 18.9399 56.5448L32.0989 63.9653C32.0989 63.9653 32.0989 63.9653 32.1345 63.9653C32.1701 63.9653 32.2056 63.9998 32.2056 63.9998H32.2412C32.2767 63.9998 32.3123 63.9998 32.3479 63.9998C32.3834 63.9998 32.419 63.9998 32.4546 63.9998H32.4901C32.5257 63.9998 32.5613 63.9653 32.5613 63.9653C32.5613 63.9653 32.5613 63.9653 32.5968 63.9653L45.7203 56.5448C45.8626 56.4413 45.9693 56.3032 45.9693 56.0961V30.176C45.9693 30.2106 45.9693 30.2106 45.9693 30.176ZM39.1764 41.4276C38.9985 41.3241 38.8207 41.3586 38.6429 41.4276L32.8814 44.7755V37.9072L44.9379 31.0734V48.2269L39.4609 51.4712V41.8763C39.4609 41.6692 39.3542 41.4967 39.1764 41.4276ZM19.7223 31.0734L31.85 37.9072V44.81L25.9817 41.4276C25.8395 41.3241 25.6261 41.3241 25.4483 41.4276C25.2704 41.5312 25.1993 41.6692 25.1993 41.8763V51.5403L19.7223 48.3995V31.0734ZM25.6972 27.0698L32.1345 30.6247C32.2767 30.7283 32.4901 30.7283 32.6324 30.6247L38.9274 27.1388L44.44 30.2106L32.3834 37.0443L20.2202 30.2106L25.6972 27.0698ZM19.7223 49.5384L25.4838 52.8173C25.6261 52.9208 25.8395 52.9208 26.0173 52.8173C26.1951 52.7137 26.2663 52.5757 26.2663 52.3686V42.7047L31.85 45.949V62.6193L19.7223 55.7855V49.5384ZM32.8814 62.6193V45.949L38.3939 42.7392V52.4031C38.3939 52.5757 38.5006 52.7483 38.6429 52.8518C38.714 52.8863 38.8207 52.9208 38.8918 52.9208C38.9985 52.9208 39.0697 52.8863 39.1764 52.8518L44.9023 49.4349V55.8545L32.8814 62.6193Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii",
    x: -3,
    y: -3,
    width: 70.6598,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.054902 0 0 0 0 0.0823529 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9832 0 0 0 0 0.4568 0 0 0 0 0.500974 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2784,
    height: 38,
    fill: "white",
    transform: "translate(18.6909 26)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDrop);
export default __webpack_public_path__ + "static/media/LogoDrop.aa72378d00ba0207e044a69354dfb7e4.svg";
export { ForwardRef as ReactComponent };